import React, { useState, useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';

const Timer = ({ timeGo = false }) => {
    const [time, setTime] = useState(0);
    const [running, setRunning] = useState(false);

    // Update running state when timeStart prop changes
    useEffect(() => {
        setRunning(timeGo);
    }, [timeGo]);

    useEffect(() => {
        let timer;
        if (running) {
            timer = setInterval(() => setTime((prev) => prev + 1), 1000);
        }
        return () => clearInterval(timer);
    }, [running]);

    const handleStart = () => {
        setTime(0); // Reset to 0
        setRunning(true);
    };
    const handleStop = () => setRunning(false);

    const formatTime = (totalSeconds) => {
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes}:${String(seconds).padStart(2, '0')}`;
    };

    return (
        <Box sx={{ textAlign: 'center', p: 2 }}>
            <Typography variant="h6">Timer: {formatTime(time)}</Typography>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: 2,
                    mt: 2,
                }}
            >
                <Button
                    variant="contained"
                    onClick={handleStart}
                    disabled={running}
                >
                    Beginnen
                </Button>
                <Button
                    variant="contained"
                    color="error"
                    onClick={handleStop}
                    disabled={!running}
                >
                    Stoppen
                </Button>
            </Box>
        </Box>
    );
};

export default Timer;
